import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";
import { cleanHtmlRestProps } from "@/lib/utils";

interface H3Props
  extends HTMLAttributes<HTMLHeadingElement>,
    CommonComponentProps {}

export function H3({ children, className, ...rest }: H3Props) {
  return (
    <h3
      className={cx(
        "font-sans text-heading-3 font-semibold text-foreground",
        className
      )}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </h3>
  );
}
